import { CREATE_CONFIGURELIMITREPONSES_FAILURE, CREATE_CONFIGURELIMITREPONSES_REQUEST, CREATE_CONFIGURELIMITREPONSES_SUCCESS } from "../Types";

const initialState = {
    loading: false,
    error: null,
    confLimitReponse: null,
};

const ConfigurLimitReponseReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_CONFIGURELIMITREPONSES_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_CONFIGURELIMITREPONSES_SUCCESS:
            return { ...state, loading: false, confLimitReponse: action.payload };
        case CREATE_CONFIGURELIMITREPONSES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default ConfigurLimitReponseReducer;
